import { render, staticRenderFns } from "./MoveDown.vue?vue&type=template&id=82c8b536"
import script from "./MoveDown.vue?vue&type=script&lang=js"
export * from "./MoveDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports